// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._30ihmxQb5TOIpN {\n  padding: 10px 12px 10px 8px;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  position: absolute;\n}\n._30ihmxQb5TOIpN:hover {\n  filter: brightness(75%);\n}\n.-ujd-1m8U6sgo_ {\n  padding: 10px 8px 10px 12px;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  position: absolute;\n}\n.-ujd-1m8U6sgo_:hover {\n  filter: brightness(75%);\n}\n._2TpQNSfccHwA-O {\n  box-sizing: border-box;\n  color: #5E6C84;\n  display: block;\n  line-height: 40px;\n  border-bottom: 1px solid rgba(9, 30, 66, 0.13);\n  margin: 0 0 6px 0;\n  overflow: hidden;\n  padding: 0 32px;\n  position: relative;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  z-index: 1;\n  text-align: center;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"closeButton": "_30ihmxQb5TOIpN",
	"backButton": "-ujd-1m8U6sgo_",
	"title": "_2TpQNSfccHwA-O"
};
export default ___CSS_LOADER_EXPORT___;
